
import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { graphqlSchema } from '../../services/graphql.schema';
import { ActivitiesNotification } from '../../models/Activities';
import { BaseReact } from '../../base.model';
import unifiedMoment from '../../services/unifiedMoment';
import './Dashboard.notifications.scss';

const moment = unifiedMoment;

interface DashboardNotificationsProps {
    history: BaseReact['history'];
}

function DashboardNotifications({ history }: DashboardNotificationsProps) {
    const [notifications, setNotifications] = useState<ActivitiesNotification[]>([]);

    useQuery(graphqlSchema.PROFILE.NOTIFICATIONS.getNotifications, {
        onCompleted: ({ getNotifications }: { getNotifications: ActivitiesNotification[] }) => {
            console.log(`getNotifications: `, getNotifications);
            setNotifications(getNotifications);
        },
        onError: (e) => {
            console.error('Error fetching getNotifications: ', e.graphQLErrors[0]);
        },
        fetchPolicy: 'cache-and-network'
    });

    const goToNotification = (notification: ActivitiesNotification) => () => {
        if (notification.resourceType === 'cotizaciones') {
            history.push({
                pathname: `/cotizacion/${notification.resourceId}`
            })
        } else if (notification.resourceType === 'facturas') {
            history.push({
                pathname: `/cotizacion/${notification.resourceId}`
            })
        }
    }

    return (
        <div
            id="DashboardActivity"
            className={`card ${!!notifications.length ? 'active' : ''}`}
        >
            <p className="activityTitle">
                Actividad
            </p>
            <div className="notificationList">
                {
                    notifications.map((notification) => (
                        <div
                            className="notification"
                            key={notification._id}
                            onClick={goToNotification(notification)}
                        >
                            <p>
                                {
                                    notification.level === 'warning' ?
                                        <span className="material-icons">
                                            warning
                                        </span> : ''
                                }
                                {
                                    notification.label
                                }
                            </p>
                            <p className="small">
                                {moment(notification.createdAt).format('DD/MMM/YYYY')}
                            </p>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default DashboardNotifications;
